define((require) => {
    "use strict";

    const Class         = require("shared/util/Class");
    const $             = require("jquery");
    const {extend}      = require("underscore");
    const Configuration = require("shared/services/Configuration");

    /**
     * Represents the <a href="https://developers.google.com/fonts/docs/developer_api" target="_blank">Google Fonts API</a> - exposing the required endpoints.
     *
     * <pre>
     *     GoogleFontsApi.mostPopular().done(function () {
     *
     *     });
     * </pre>
     *
     * @class GoogleFontsApi
     * @author Kim
     */
    const GoogleFontsApi = Class.extend({

        /**
         * Fetches a list of fonts offered by the Google Fonts service.
         *
         * @return {Promise} A <tt>Promise</tt> that resolves with a list of fonts offered by the Google Fonts service.
         *
         * @see  https://developers.google.com/fonts/docs/developer_api
         */
        all() {
            return this._get();
        },

        mostPopular() {
            return this._get({sort: "popularity"});
        },

        _get(options) {
            return $.getJSON(Configuration.googleWebFontsApiBaseUrl, extend({key: Configuration.googleWebFontsApiKey}, options || {}))
                .then((response) => response);
        },

        toString() {
            return "GoogleFontsApi[]";
        }

    });

    return new GoogleFontsApi();
});



// WEBPACK FOOTER //
// ./src/editor/services/fonts/GoogleFontsApi.js